/**
 * djb2 — a tiny, fast, non-cryptographic string hash (Daniel J. Bernstein).
 *
 * Returns an unsigned 32-bit integer. Deterministic and stable across runs,
 * which makes it suitable for deriving a consistent-but-arbitrary value from a
 * string.
 *
 * DO NOT USE for security/cryptographic purposes.
 */
export function djb2(input: string): number {
    let hash = 5381;
    for (let i = 0; i < input.length; i++) {
        // hash * 33 + charCode, truncated to 32 bits each step
        hash = (hash * 33 + input.charCodeAt(i)) | 0;
    }
    return hash >>> 0;
}
